<template>
  <div class="box">
    <div class="header">
      <div class="avatar-container">
        <img :src="
          !issin
            ? muser
            : userinfo.portrait
              ? (config!=null ?config.fileServerUrl:'') + userinfo.portrait
              : muser
        " alt="用户头像" class="avatar" />
      </div>

      <div class="user-info">
        <div class="names">
          <h3 class="nickname">{{ issin ? userinfo.nickName : "游客用户" }}</h3>
          <p class="user-id">{{ issin ? `ID:${userinfo.chatNo ? userinfo.chatNo : userinfo.userId}` : "" }}</p>
        </div>
      </div>

      <div class="action-buttons">
        <button v-if="!issin" class="login-btn" @click="toJump('Login')">点击登录</button>
        <button v-if="issin&&!isApp" class="logout-btn" @click="toDel()">退出登录</button>
      </div>
    </div>
    
    <div v-if="payGroupInfo" class="menu-container">
      <div class="menu-grid">
        <div 
          class="menu-item" 
          @click="toJump(item.path)" 
          v-for="(item, i) in (payGroupInfo.type === 0 ? fullList : listRecharge)" 
          :key="i"
        >
          <svg v-if="item.name === '推广组信息'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333333" stroke-width="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
          <svg v-else-if="item.name === '成员列表'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <svg v-else-if="item.name === '收益流水' || item.name === '充值流水'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cccccc" stroke-width="2">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
          <svg v-else-if="item.name === '数据概览'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2">
            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
          </svg>
          <svg v-else-if="item.name === '所属推广组列表'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cccccc" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <svg v-else-if="item.name === '所属推广组流水'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2">
            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
          </svg>
          <svg v-else-if="item.name === '分成统计'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cccccc" stroke-width="2">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
          <div class="menu-text">{{ item.name }}</div>
          <!-- <img src="@/assets/image/right.png" alt="进入" class="arrow-icon" /> -->
        </div>
      </div>
    </div>
    
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
import muser from "@/assets/image/user.png";
// import { wxqq } from "../utils/utils";
import Mask from "../components/Mask";
import { Toast } from 'vant';

export default {
  name: "Home",
  data() {
    return {
      isApp: localStorage.getItem("isApp"),
      list: [
        {
          name: "推广组信息",
          path: "GroupInfo",
          icon: "setting-o"
        },
        {
          name: "成员列表",
          path: "MemberList",
          icon: "user-o"
        },
        {
          name: "收益流水",
          path: "Income",
          icon: "trend-chart"
        }, {
            name: "数据概览",
            path: "DataView",
            icon: "line-chart"
          },
        // 只有当有下级组时才显示这两个菜单项（直接从localStorage获取，避免异步问题）
        ...(localStorage.getItem('isTopLevel') === 'true' ? [
          {
            name: "所属推广组列表",
            path: "twoMemberList",
            icon: "friends-o"
          },
          {
            name: "所属推广组流水",
            path: "twolevel",
            icon: "pie-chart"
          },
        ] : []),
        {
          name:"分成统计",
          path:"Comission",
          icon: "gift-o"
        }
      ],
      listRecharge: [
        {
          name: "推广组信息",
          path: "GroupInfo",
          icon: "setting-o"
        },
        {
          name: "成员列表",
          path: "MemberList",
          icon: "user-o"
        },
        {
          name: "充值流水",
          path: "Income",
          icon: "trend-chart"
        },
      ],
      issin: false,
      userinfo: {
        nickName: "",
        userId: "",
        portrait: "",
        isCertified: false,
      },
      payGroupInfo: null,
      muser,
      marke: false,
    };
  },
  components: {
    Mask,
  },
  computed: {
    config: () => {
      return JSON.parse(localStorage.getItem("config"))
    },
    // 使用计算属性返回完整菜单列表
    fullList() {
      // 基础菜单项
      const baseItems = [
        {
          name: "推广组信息",
          path: "GroupInfo",
          icon: "setting-o"
        },
        {
          name: "成员列表",
          path: "MemberList",
          icon: "user-o"
        },
        {
          name: "收益流水",
          path: "Income",
          icon: "trend-chart"
        }, 
        {
          name: "数据概览",
          path: "DataView",
          icon: "line-chart"
        }
      ];
      
      // 根据是否有下级组决定是否添加条件菜单项（直接从localStorage获取，避免异步问题）
      const isTopLevel = localStorage.getItem('isTopLevel') === 'true'
      if (isTopLevel) {
        baseItems.push(
          {
            name: "所属推广组列表",
            path: "twoMemberList",
            icon: "friends-o"
          },
          {
            name: "所属推广组流水",
            path: "twolevel",
            icon: "pie-chart"
          }
        );
      }
      
      // 添加分成统计项
      baseItems.push({
        name:"分成统计",
        path:"Comission",
        icon: "gift-o"
      });
      
      return baseItems;
    }
  },
  created() {
    if (localStorage.getItem("token")) {
      this.issin = true
      this.getuserinfo()
      this.getPayGroupInfo()
    } else {
      this.$router.push({ path: "Login" })
    }
  },
  mounted() {
    // this.marke = wxqq();
  },
  methods: {
       // 计算属性判断是否为顶级用户
    
    toJump(path) {
      if (!this.issin) {
        return this.$router.push({ path: "Login" })
      }
      this.$router.push({ path: path })
    },
    toDel() {
      this.$request.post("/api/user/passport/logout").then(() => {
        localStorage.setItem("token", "")
        this.issin = false
        this.$router.push({ path: "Login" })
      });
    },
    getuserinfo() {
      this.$request.post("/api/user/mine/userInfo").then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            this.userinfo = res.data.data
          }
        }
      });
    },
    getPayGroupInfo() {
      this.$request.postJson('/api/user/pay_group/info', {}).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            this.payGroupInfo = res.data.data
          } else {
            Toast('未查询到推广组信息')
            this.toDel()
          }
        }
      })
    },
  },
};
</script>
<style scoped lang="less">
/* 全局样式重置与基础设置 */
* {
  box-sizing: border-box;
}

.box {
  min-height: 100vh;
  background-color: #fafafa;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  color: #333333;
  padding-bottom: 20px;
}

/* 头部样式 */
.header {
  display: flex;
  align-items: center;
  padding: 24px 20px;
  background: #FFD700;
  color: #333333;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.avatar-container {
  margin-right: 16px;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 3px solid rgba(0, 0, 0, 0.1);
  object-fit: cover;
  background-color: #f5f5f5;
}

.user-info {
  flex: 1;
}

.names {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nickname {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #333333;
}

.user-id {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin: 0;
}

.action-buttons {
  display: flex;
  align-items: center;
}

.login-btn, .logout-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  background-color: rgba(0, 0, 0, 0.05);
  color: #333333;
  backdrop-filter: blur(5px);
}

.login-btn:hover, .logout-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

/* 菜单容器样式 */
.menu-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 0 10px;
}

/* 网格布局 */
.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

/* 菜单项样式 */
.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  min-height: 100px;
  border: 1px solid #e0e0e0;
}

.menu-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  border-color: #cccccc;
}

/* 菜单图标样式 */
.menu-item svg {
  margin-bottom: 10px;
}

/* 菜单文本 */
.menu-text {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  text-align: center;
  margin-bottom: 8px;
}

/* 箭头图标 */
.arrow-icon {
  width: 16px;
  height: 16px;
  opacity: 0.6;
  transition: transform 0.2s ease;
  filter: brightness(0) invert(1);
}

.menu-item:hover .arrow-icon {
  transform: translateX(3px);
  opacity: 0.8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 20px 16px;
  }
  
  .avatar {
    width: 56px;
    height: 56px;
  }
  
  .nickname {
    font-size: 16px;
  }
  
  .user-id {
    font-size: 13px;
  }
  
  .menu-container {
    margin: 0 16px;
    padding: 0;
  }
  
  .menu-grid {
    gap: 10px;
  }
  
  .menu-item {
    padding: 16px 10px;
    min-height: 90px;
  }
  
  .menu-icon {
    width: 28px;
    height: 28px;
  }
  
  .menu-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .menu-grid {
    gap: 8px;
  }
  
  .menu-item {
    padding: 14px 8px;
    min-height: 80px;
  }
}
</style>
